import { Injectable } from '@angular/core';
import { LoadingController } from '@ionic/angular';

@Injectable({ providedIn: 'root' })
export class LoadingProvider {
    constructor(
        private loadingController: LoadingController,
    ) { }

    async create(): Promise<HTMLIonLoadingElement> {
        return await this.loadingController.create({
            duration: 30 * 1000,
            backdropDismiss: false,
            showBackdrop: true,
        });
    }
}
